export const customerServicePhone = '030 660 6400';
export const customerServicePhoneLink = 'tel:' + customerServicePhone;